const images = [
  {
    "id": 1,
    "name": "images/thanos.jpg"
  },
  {
    "id": 2,
    "name": "images/ironMan.jpeg"
  },
  {
    "id": 3,
    "name": "images/doctorStrange.jpg"
  },
  {
    "id": 4,
    "name": "images/thor.jpg"
  },
  {
    "id": 5,
    "name": "images/captainAmerica.jpg"
  },
  {
    "id": 6,
    "name": "images/blackPanther.jpg"
  },
  {
    "id": 7,
    "name": "images/hulk.jpg"
  },
  {
    "id": 8,
    "name": "images/spiderMan.jpg"
  },
  {
    "id": 9,
    "name": "images/blackWidow.jpg"
  },
  {
    "id": 10,
    "name": "images/drax.jpg"
  },
  {
    "id": 11,
    "name": "images/captainMarvel.jpg"
  },
  {
    "id": 12,
    "name": "images/rocket.jpg"
  }
]

export default images;
